import React from "react"
import { Controller, useFormContext } from "react-hook-form"
import {
  spaceSizes,
  SPACE_TAG_STYLE,
  SPACE_TAG_FLOORS,
  SPACE_TAG_WALLS,
} from "../../../api/Definitions"
import FormInput from "../../../components/Form/Inputs/FormInput"
import Textarea from "../../../components/Form/Inputs/Textarea"
import AsyncCreatableTag from "../../../components/Form/Select/AsyncCreatableTag"
import SelectInput from "../../../components/Form/Select/Select"

const SpaceAbout = () => {
  const { control } = useFormContext()
  return (
    <div className="scrollable row">
      <div className="col-12">
        <Controller
          render={({ value, onChange }) => (
            <Textarea label="About" value={value} onChange={onChange} />
          )}
          name="about"
        />
      </div>
      <div className="col-6">
        <FormInput name="wallLength" label="Wall Length" />
        <FormInput name="floorArea" label="Floor area" />
        <FormInput name="ceilingHeight" label="Ceiling height" />
        <FormInput name="roomNumber" label="Room number" />
      </div>
      <div className="col-6">
        <Controller
          control={control}
          name="size"
          render={({ value, onChange }) => (
            <SelectInput
              value={value}
              options={spaceSizes}
              name="size"
              label="Size"
              onChange={onChange}
              isClearable
            />
          )}
        />
        <AsyncCreatableTag group={SPACE_TAG_STYLE} name="tags" label="Tags" />
        <AsyncCreatableTag group={SPACE_TAG_WALLS} name="walls" label="Walls" />
        <AsyncCreatableTag
          group={SPACE_TAG_FLOORS}
          name="floors"
          label="Floors"
        />
      </div>
    </div>
  )
}

export default SpaceAbout
